module.exports = __webpack_public_path__ + "assets/img/tit4.8226d0b0.png";